import { orderLiquidityCapsuleDescription } from './components/description/orderLiquidityCapsuleDescription';
import React from 'react';
import {
    initialVenueAnalysisCapsuleConfigState,
    VenueAnalysisCapsuleConfigState,
} from 'widgets/venueAnalysis/capsules/store/VenueAnalysisCapsuleConfigState.ts';
import {
    WidgetStrategyWithConfig,
    WidgetStrategyWithStreamByRequestUid,
} from 'widgets/WidgetRegistry.ts';
import { VenueAnalysisByOrderIdsOrSymbolStreamRequest } from 'widgets/venueAnalysis/api/VenueAnalysisByOrderIdsOrSymbolStreamRequest.ts';
import { WidgetCategory } from 'widgets/WidgetCategory.ts';
import { venueAnalysisStreamConfig } from 'widgets/venueAnalysis/store/stream/stream-config.ts';
import { PortfolioSelectionRequirements } from 'widgets/PortfolioSelectionRequirements.ts';
import { OrderLiquidityCapsule } from './components/OrderLiquidityCapsule.tsx';

export const orderLiquidityCapsuleStrategy: WidgetStrategyWithStreamByRequestUid<VenueAnalysisByOrderIdsOrSymbolStreamRequest> &
    WidgetStrategyWithConfig<VenueAnalysisCapsuleConfigState> = {
    supportedHosts: ['tile'],
    reactComponentType: OrderLiquidityCapsule,
    title: 'Order Liquidity',
    categories: [WidgetCategory.FILL_CAPSULES],
    initialConfigState: initialVenueAnalysisCapsuleConfigState,
    description: orderLiquidityCapsuleDescription,
    portfolioSelectionRequirements:
        PortfolioSelectionRequirements.PositionFromAtLeastOneOrder,
    managedStreamConfig: venueAnalysisStreamConfig,
    portfolioSelectionRequirementsWithoutOrdersStream:
        PortfolioSelectionRequirements.SingleSymbol,
};
